import React, {Component} from 'react';

import Book from './components/book';
import VideoBackground from './components/videobackground';
import Capitolo from './components/capitolo';
import Quarta from './components_novel/quarta';
import Anteprima from './components/anteprima';
import Ebook from './components/ebook';
import Autore from './components/autore';
import Estratto from './components/estratto';
//import Estratto2 from './components/estratto2';
//import Contattaci from './components/contattaci';
import BooktrailerModal from './components/booktrailermodal'
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Widget from './components/widget';
import LandingSections from './components/landingsections';
import CreativeArticleTeaser from './components/creativearticleteaser';
import Seo from './components/seo';
import {getArticlePath, getLatestCreativeArticle} from './data/creativeArticles';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';
import videoBackgroundImage from './images/verso-hemelslinn-sfondo-video-2.webp';
import backgroundEstrattoImage1 from './images/khaleb-alla-deriva.webp';
import backgroundBookImage1 from './images/volume-verso-hemelslinn.webp';
import backgroundBookImage2 from './images/copertina-verso-hemelslinn.webp'; 
import backgroundBookImage3 from './images/frontespizio-verso-hemelslinn.webp';
import backgroundBookImage4 from './images/ebook.webp';
import backgroundCapitoloImage1 from './images/sommario/00-preludio-02png.webp';
import backgroundCapitoloImage2 from './images/sommario/01-Prixian-02.webp';
import backgroundCapitoloImage3 from './images/sommario/02-la-rotta-si-apre-03.webp';
import backgroundCapitoloImage4 from './images/sommario/03-l-inseguimento-2.webp';
import backgroundCapitoloImage5 from './images/sommario/04-un-incontro-inatteso-03.webp';
import backgroundCapitoloImage6 from './images/sommario/05-lisier-02.webp';
import backgroundQuartaImage from './images/book-fronte-retro-verso-hemelslinn.webp';
import backgroundEbookImage from './images/tablet-smartphon-verso-hemelslinn.webp';
import backgroundAutoreSfondoImage from './images/verso-hemelslinn-stella-plasma.webp';
import backgroundAutoreImage from './images/foto-sito-web.webp';
//import backgroundEstrattoImage2 from './images/il-dilemma-del-gorilla-03.webp';
//import backgroundEstrattoImage3 from './images/tablet-smartphon-verso-hemelslinn.webp';

import booktrailerModalImage from './images/copertina-booktrailer-v4.5f-youtube-verso-hemelslinn.webp';
import videoBackgroundLocal from './images/verso-hemelslinn-background-v.3.1.mp4';


const videoBackgroundStyle = {backgroundImage: `url(${videoBackgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center center', backgroundAttachment: 'fixed', height: '700px'};
const styleBook1 = {backgroundImage: `url(${backgroundBookImage1})`,};
const styleBook2 = {backgroundImage: `url(${backgroundBookImage2})`,};
const styleBook3 = {backgroundImage: `url(${backgroundBookImage3})`,};
const styleBook4 = {backgroundImage: `url(${backgroundBookImage4})`,};
const styleCapitolo1 = {backgroundImage: `url(${backgroundCapitoloImage1})`,};
const styleCapitolo2 = {backgroundImage: `url(${backgroundCapitoloImage2})`,};
const styleCapitolo3 = {backgroundImage: `url(${backgroundCapitoloImage3})`,};
const styleCapitolo4 = {backgroundImage: `url(${backgroundCapitoloImage4})`,}; 
const styleCapitolo5 = {backgroundImage: `url(${backgroundCapitoloImage5})`,};
const styleCapitolo6 = {backgroundImage: `url(${backgroundCapitoloImage6})`,};
const sectionQuartaStyle = {backgroundImage: `url(${backgroundQuartaImage})`,};
const sectionEbookStyle = {backgroundImage: `url(${backgroundEbookImage})`,};
const sectionAutoreSfondoStyle = {backgroundImage: `url(${backgroundAutoreSfondoImage})`,};
const sectionAutoreStyle = {backgroundImage: `url(${backgroundAutoreImage})`,};
const EstrattoStyle1 = {backgroundImage: `url(${backgroundEstrattoImage1})`,};
//const EstrattoStyle2 = {backgroundImage: `url(${backgroundEstrattoImage2})`,};
//const EstrattoStyle3 = {};
const campaignLink = 'https://hemelslinn.s.gy/vh-web-hem-land';

// Funzione per aggiungere dei javascript esterni
export function AddLibrary(urlOfTheLibrary) {
	const script = document.createElement('script');
	script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
	script.async = true;
	document.body.appendChild(script);
}


class App extends Component {
	state = {
		aBooks: [
			{id: 0, bookTitolo: "Volume", bookStile: styleBook1, bookDescrizione: '<p>Formati: <span>6"x9" - 15,2x22,8cm</span></p><p>Rilegature: <span>copertina rigida laminata</span></p><p>Tipo: <span>fresato</span></p>'},
			{id: 1, bookTitolo: "Copertina", bookStile: styleBook2, bookDescrizione: "<p>Colori: <span>quadricromia</span></p><p>Carta: <span>rivestita lucida</span></p><p>Spessore: <span>cartone pressato 1.600g/m<sup>2</sup></span></p><p>Laminazione: <span>lucida</span></p>"},
			{id: 2, bookTitolo: "Pagine", bookStile: styleBook3, bookDescrizione: "<p>Numero: <span>418</span></p><p>Carta: <span>avorio, uso mano</span></p><p>Spessore: <span>90g/m<sup>2</sup></span></p>"},
			{id: 3, bookTitolo: "EBook", bookStile: styleBook4, bookDescrizione: "<p>Formati: <span>Epub, Kindle, Mobi, PDF</span></p><p>Protezione: <span>nessuna</span></p><p>Accessibilità: <span>accessibile</span></p><p>Dimensione: <span>1.626 KB</span></p>"}
		],
		aCapitolo: [
			{id: 0, capitoloStile: styleCapitolo1, capitoloTitolo: "Preludio", capitoloDescrizione: "Un bagliore impossibile apre una storia destinata a spostare ogni rotta."},
		{id: 1, capitoloStile: styleCapitolo2, capitoloTitolo: "Prixian", capitoloDescrizione: "Una società ordinata, un equipaggio pronto, e una missione che comincia molto prima della partenza."},
		{id: 2, capitoloStile: styleCapitolo3, capitoloTitolo: "La rotta si apre", capitoloDescrizione: "La Delphís lascia ciò che conosce e si inoltra in un viaggio dove ogni incontro può cambiare il destino."},
		{id: 3, capitoloStile: styleCapitolo4, capitoloTitolo: "L’inseguimento", capitoloDescrizione: "Quando la libertà diventa una corsa, ogni scelta a bordo può decidere la salvezza."},
		{id: 4, capitoloStile: styleCapitolo5, capitoloTitolo: "Un incontro inatteso", capitoloDescrizione: "Tra pericolo e diffidenza, una presenza inattesa può trasformare una fuga in una possibilità."},
		{id: 5, capitoloStile: styleCapitolo6, capitoloTitolo: "Lisier", capitoloDescrizione: "Davanti a una luce immensa, la Delphís affronta il limite sottile tra meraviglia e rischio."}
		],
		aNavbarLinks: [
			{id: 1, linkHref: "/#cos-e", linkNome: "COS’È"},
			{id: 2, linkHref: "/#diverso", linkNome: "PERCHÉ È DIVERSO"},
			{id: 3, linkHref: "/#campaign", linkNome: "RICOMPENSE"},
			{id: 4, linkHref: "/#faq", linkNome: "FAQ"},
			{id: 5, linkHref: "/articoli", linkNome: "ARTICOLI"},
			{id: 6, linkHref: "/#preview", linkNome: "ANTEPRIMA"},
		],
	}


	render() {
		const latestArticle = getLatestCreativeArticle();
		const latestArticlePath = latestArticle ? getArticlePath(latestArticle) : '/articoli';
		const latestArticleTitle = latestArticle ? latestArticle.title : 'Articoli sulla scrittura di Verso Hemelslinn';
		const homeSitelinks = [
			{
				name: 'Sommario di Verso Hemelslinn',
				description: 'Capitoli, rotta della Delphís e prime tappe del romanzo senza spoiler decisivi.',
				url: 'https://versohemelslinn.it/summary',
				path: '/summary',
			},
			{
				name: latestArticleTitle,
				description: 'L’ultimo articolo pubblicato nel laboratorio narrativo di Verso Hemelslinn.',
				url: `https://versohemelslinn.it${latestArticlePath}`,
				path: latestArticlePath,
			},
			{
				name: 'Cos’è Verso Hemelslinn',
				description: 'Una guida chiara alla space opera romantica italiana senza alieni.',
				url: 'https://versohemelslinn.it/cos-e-verso-hemelslinn/',
				path: '/cos-e-verso-hemelslinn/',
			},
			{
				name: 'Articoli e percorsi editoriali',
				description: 'Approfondimenti su scrittura, personaggi, worldbuilding, relazioni, ebook e produzione editoriale.',
				url: 'https://versohemelslinn.it/articoli',
				path: '/articoli',
			},
			{
				name: 'Maurizio Feruglio',
				description: 'La pagina dell’autore ed editore indipendente che firma Verso Hemelslinn.',
				url: 'https://versohemelslinn.it/maurizio-feruglio/',
				path: '/maurizio-feruglio/',
			},
			{
				name: 'Campagna crowdfunding',
				description: 'La pagina per sostenere il romanzo e salire a bordo della Delphís.',
				url: campaignLink,
				path: campaignLink,
			},
		];
		const homeJsonLd = {
			'@context': 'https://schema.org',
			'@graph': [
				{
					'@type': 'WebSite',
					'@id': 'https://versohemelslinn.it/#website',
					url: 'https://versohemelslinn.it/',
					name: 'Verso Hemelslinn',
					inLanguage: 'it-IT',
					publisher: {
						'@type': 'Organization',
						name: 'Eliosfera Editrice',
					},
				},
				{
					'@type': 'Book',
					'@id': 'https://versohemelslinn.it/#book',
					name: 'Verso Hemelslinn',
					author: {
						'@id': 'https://versohemelslinn.it/maurizio-feruglio/#person',
					},
					publisher: {
						'@type': 'Organization',
						name: 'Eliosfera Editrice',
					},
					inLanguage: 'it-IT',
					genre: ['Space opera', 'Fantascienza romantica'],
					description: 'Verso Hemelslinn è una space opera romantica e umanista senza alieni: un romanzo tra stelle, amore, libertà e scelte morali.',
					image: 'https://versohemelslinn.it/images/copertina-verso-hemelslinn.webp',
				},
				{
					'@type': 'WebPage',
					'@id': 'https://versohemelslinn.it/#webpage',
					url: 'https://versohemelslinn.it/',
					inLanguage: 'it-IT',
					name: 'Verso Hemelslinn | Space opera romantica senza alieni',
					isPartOf: {
						'@id': 'https://versohemelslinn.it/#website',
					},
					about: {
						'@id': 'https://versohemelslinn.it/#book',
					},
					description: 'Verso Hemelslinn è una space opera romantica e umanista senza alieni: un romanzo di Maurizio Feruglio tra stelle, amore, libertà e scelte morali.',
					hasPart: homeSitelinks.map((link) => ({
						'@type': 'WebPage',
						name: link.name,
						url: link.url,
						description: link.description,
					})),
				},
				{
					'@type': 'ItemList',
					'@id': 'https://versohemelslinn.it/#percorsi-principali',
					name: 'Percorsi principali di Verso Hemelslinn',
					itemListElement: homeSitelinks.map((link, index) => ({
						'@type': 'ListItem',
						position: index + 1,
						name: link.name,
						url: link.url,
					})),
				},
			],
		};

		return (
			<>
				<div className="page">
					<Seo
						title="Verso Hemelslinn"
						description="Una space opera romantica e umanista senza alieni. Scopri il romanzo di Maurizio Feruglio e sostieni una storia tra stelle, amore, libertà e scelte morali."
						path="/"
						image="/images/copertina-verso-hemelslinn.webp"
						jsonLd={homeJsonLd}
					/>
					<Navbar 
						linkSito='/'
						logo={logo}
						deskLogo='Logo di Verso Hemelslinn'
						brandName='Verso Hemelslinn'
						aNavbarLinks = {this.state.aNavbarLinks}
					/>
					<div id="pagina">

						{/* SECTION VIDEOBACKGROUND */}
						{/*<VideoBackground 
							backgroundStyle={videoBackgroundStyle}
							backgroundVideo={videoBackgroundLocal}
							titolo="VERSO<br />HEMELSLINN"
							romanzo="un romanzo di"
							autore="MAURIZIO FERUGLIO"
							tagLine="Un'emozionante avventura, un amore tra le stelle."
							tagLine2="Il romanzo è disponibile su Amazon nei formati ebook, copertina rigida e copertina flessibile."
							buttonPrenota="ACQUISTA"
							buttonLink='https://amzn.to/43biilu'
						/>*/}

						{/* SECTION VIDEOBACKGROUND 2 */}
						<VideoBackground 
							backgroundStyle={videoBackgroundStyle}
							backgroundVideo={videoBackgroundLocal}
							titolo="VERSO<br />HEMELSLINN"
							romanzo="un romanzo di"
							autore="MAURIZIO FERUGLIO"
							tagLine="E se il viaggio più importante non fosse nello spazio... ma tra due persone?"
							tagLine2="Una space opera romantica senza alieni."
							buttonPrenota="Sostieni la campagna"
							buttonLink='https://hemelslinn.s.gy/vh-web-hem-land'
							secondaryButtonText="Scopri la storia"
							secondaryButtonLink="/#cos-e"
						/>

						<section className="home-search-paths" aria-labelledby="home-search-paths-title">
							<div className="container">
								<p className="landing-kicker">Percorsi principali</p>
								<h2 id="home-search-paths-title">Esplora Verso Hemelslinn</h2>
								<div className="home-search-paths-grid">
									{homeSitelinks.map((link) => (
										<a key={link.name} className="home-search-path-card" href={link.path}>
											<span>{link.name}</span>
											<small>{link.description}</small>
										</a>
									))}
								</div>
							</div>
						</section>

						<LandingSections />

						{/* SECTION BOOK */}
						<section id="book" className="ftco-section ftco-no-pt ftco-featured-model">
							<div className="container-fluid">
								<div className="row">
									{this.state.aBooks.map(sectionbook => (
										<Book
											key={sectionbook.id}
											sectionbook={sectionbook}
										/>
									))}
								</div>
							</div>
						</section>


						{/* SECTION ESTRATTO */}
						{/*<Estratto
							estrattoId="beyond"
							estrattoStile={EstrattoStyle1}
							estrattoTitolo="Amore tra le stelle"
							estrattoContenuto="Il buzzer iniziò a suonare, sul visore apparve l’alert rosso. Il casco che sembrava integro, in realtà aveva una microcrepa alla giuntura della visiera. Il messaggio che ricevette era che se fosse uscita in attività extraveicolare, in poco più di trenta secondi si sarebbe spaccato in due.
							Se lo sganciò e, in un impeto di rabbia, lo scaraventò sulla parete, ottenendo solo di sbattere contro la parete opposta. Diede un pugno allo sportello dello scomparto tute. In quel momento il dolore fisico era corroborante, meno intenso del dolore emotivo. Si avvicinò al portello esterno e guardò attraverso l’oblò. Khàleb era a soli quindici metri da lei e non poteva raggiungerlo, non poteva salvarlo! Si appoggio con la fronte al vetro, afferrò la maniglia con la mano sinistra e diede con la destra diversi pugni, come se volesse frantumare la parete vitrea. Pianse."
							estrattoButton="ACQUISTA"
							estrattoButtonLink='https://amzn.to/43biilu'
						/>*/}
						
						{/* SECTION ESTRATTO */}
						<Estratto
							estrattoId="beyond"
							estrattoStile={EstrattoStyle1}
							estrattoTitolo="Amore tra le stelle"
							estrattoContenuto="Il buzzer iniziò a suonare, sul visore apparve l’alert rosso. Il casco che sembrava integro, in realtà aveva una microcrepa alla giuntura della visiera. Il messaggio che ricevette era che se fosse uscita in attività extraveicolare, in poco più di trenta secondi si sarebbe spaccato in due.
							Se lo sganciò e, in un impeto di rabbia, lo scaraventò sulla parete, ottenendo solo di sbattere contro la parete opposta. Diede un pugno allo sportello dello scomparto tute. In quel momento il dolore fisico era corroborante, meno intenso del dolore emotivo. Si avvicinò al portello esterno e guardò attraverso l’oblò. Khàleb era a soli quindici metri da lei e non poteva raggiungerlo, non poteva salvarlo! Si appoggio con la fronte al vetro, afferrò la maniglia con la mano sinistra e diede con la destra diversi pugni, come se volesse frantumare la parete vitrea. Pianse."
							estrattoButton="SALVA KHÀLEB!"
							estrattoButtonLink='https://hemelslinn.s.gy/vh-web-hem-land'
						/>						


						{/* SECTION QUARTA DI COPERTINA */}				
						<Quarta 
							stileQuarta={sectionQuartaStyle}
							titoloQuarta="LA STORIA"
							descrizioneQuarta="
							<p>
							<b>I mondi di Galàxias stanno cambiando</b><br />
							Le corporazioni controllano i viaggi interstellari.<br />
							La libertà di esplorare non appartiene più a tutti.</p>
							
							<p><b>La Delphís è alla deriva</b><br />
							Un equipaggio.<br />
							Una missione.<br />
							Una scelta che può cambiare tutto.</p>
							
							<p><b>E poi c’è qualcosa di ancora più pericoloso</b><br />
							Legarsi a qualcuno.</p>"
						/>

						{/* SECTION BOOKTRAILER */}
						<BooktrailerModal
							booktrailerModalId="booktrailer"
							booktrailerModalImage={booktrailerModalImage}
							booktrailerModalVideo="JNJceYCu06Q"
							booktrailerModalTitolo="BOOK TRAILER"
							booktrailerModalTagLine="Immergiti nel trailer e lasciati coinvolgere dall'avventura!"
							booktrailerModalAltImg="Astronave Delphís nello spazio nel booktrailer di Verso Hemelslinn"
						/>


						{/* SECTION AUTORE */}
						<Autore
							autoreStileSfondo={sectionAutoreSfondoStyle}
							autoreStile={sectionAutoreStyle}
							autoreTitle="L'AUTORE"
							autoreNome="Maurizio Feruglio"
							autoreBiografia="La sua passione per la letteratura lo ha portato a scrivere alcuni romanzi e racconti esplorando vari generi narrativi.
							Ha pubblicato le raccolte di racconti <em>ESSERE</em> e <em>LETTERE</em>."
							autoreLinkText="Per saperne di più"
							autoreLinkHref="/maurizio-feruglio/"
						/>


						{/* SECTION SUMMARY */}
						<section id="summary" className="ftco-section ftco-no-pb">
							<div className="container-fluid px-4">
								<div className="row d-flex">
									<div className="col-md-6 col-lg-3 d-flex align-items-center ftco-animate">
										<div className="heading-section text-center">
											<h2 className="">SOMMARIO</h2>
											<h3>Scorri i capitoli e scopri Hemelslinn!</h3>
										</div>
									</div>
									{this.state.aCapitolo.map(sectioncapitolo => (
										<Capitolo
										key={sectioncapitolo.id}
										sectioncapitolo={sectioncapitolo} />
									))}
									<div className="col-md-6 col-lg-3 d-flex justify-content-center align-items-center ftco-animate">
										<div className="btn-view">
											<h3><a href="/summary" className="btn btn-info py-3 px-5">Immergiti in Hemelslinn</a></h3>
										</div>
									</div>
								</div>
							</div>
						</section>
						{/* SECTION WIDGET */}
						<Widget
							widgetId="SocialProof"
							widgetTitolo="DICONO DI VERSO HEMELSLINN..."
							widgetContenuto='Chi ha letto questa storia mi ha scritto:<br />
							<ul className="text-inner pl-md-5">
							<li><em>Questa storia è una bomba! Quando la pubblichi!?</em> — Maria.</li>
							<li><em>Non me l’aspettavo, è talmente bella… davvero l’hai scritta tu!?</em> — Antonella.</li>
							<li><em>Davvero è una bella storia ambientata in uno spazio tecnologicamente futuribile</em> — Riccardo.</li>
							<li><em>Verso Hemelslinn non è solo un romanzo d’intrattenimento. È  un romanzo con un messaggio nobile […] Siamo stati per più di un secolo a osservare il mondo scivolare via, ‘come lacrime nella pioggia’. Che non sia arrivato il momento per guardare avanti, verso qualcosa di migliore? Appunto, Verso Hemelslinn?<em /> — Davide.</li>
							<li><em>Il tuo romanzo è davvero bello, merita di essere letto da tutti</em> — Lidia.</li>
							<li><em>Mi ha emozionato</em> — Debora.</li>
							<li><em>Leggendolo ho vissuto un’altra vita un sogno bellissimo</em> — Rossella.</li>
							<li><em>Intrigante e con colpi di scena che mi hanno destabilizzato, ma l’ho amata</em> — Mariagrazia.</li>
							</ul>
							Se queste esperienze ti hanno coinvolto, sali sulla Delphís ed esplora i confini della libertà umana!'
							widgetButton="UNISCITI ALL'EQUIPAGGIO, ORA!"
							widgetButtonLink='https://hemelslinn.s.gy/vh-web-hem-land'
						/>

						{/* SECTION ANTEPRIMA */}
						<Anteprima
							anteprimaTitolo="Ricevi l’estratto gratuito di Verso Hemelslinn"
							anteprimaTagLine="
							✔ Estratto gratuito<br />
							✔ Accesso anticipato<br />
							✔ Aggiornamenti sul progetto<br />
							✔ Contenuti esclusivi sulla Delphís<br />
							Riceverai nella tua casella di posta il link per scaricare l'estratto gratuito in formato PDF."
							anteprimaAction="https://towardhemelslinn.us11.list-manage.com/subscribe?u=81158fe55b1b7e6f79918d667&id=f6b53c0a1e" //Link form Mailchimp
							anteprimaButton="ACCEDI ALLA MISSIONE"
							anteprimaConsenso="Accetto il trattamento dei miei dati personali. "
							anteprimaInformativaPrivacy="Informativa sulla privacy"
							anteprimaPrivacy="Consenso alla privacy"
							anteprimaNomePlaceholder="Nome"
							anteprimaEmailPlaceholder="Indirizzo Email"
						/>


						{/* SECTION EBOOK */}
						{/*<Ebook
							ebookStile={sectionEbookStyle}
							ebookTitle="VERSO HEMELSLINN ebook ePub"
							ebookTagLine="Leggilo anche in ebook su tutti i dispositivi!"
							ebookElenco='<li><span class="ion-ios-checkmark-circle mr-2"></span><span class="ebook-feature-text"><em>Accessibile</em> per non vedenti e ipovedenti, in formato epub3.</span></li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Altri formati disponibili: Kindle, Mobi e PDF.</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo con uno screen reader o un lettore braille.</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo con Kindle, Kobo e altri eReader.</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo su tablet, smartphone o PC.</li>'
							ebookInfoAccessibilita="Per saperne di più sull'accessibilità, leggi (in italiano):"
							ebookLinkAccessibilita="https://www.eliosfera.it/ebook-con-contenuti-accessibili-eliosfera-editrice"
							ebookTitleLink="Link all'articolo Ebook con contenuti accessibili."
							ebookDescAccessibilita="Ebook con contenuti accessibili"
							ebookCallAction="Allora, cosa stai aspettando? L'avventura ti aspetta anche in digitale!"
							ebookLink="https://hemelslinn.s.gy/vh-web-hem-land"
							ebookButton="ACQUISTA L'EBOOK"
							ebookButton="SOSTIENI VERSO HEMELSLINN!"
							ebookLink='https://hemelslinn.s.gy/vh-web-hem-land'
						/>*/}

						{/* SECTION EBOOK */}
						<Ebook
							ebookStile={sectionEbookStyle}
							ebookTitle="VERSO HEMELSLINN ebook ePub"
							ebookTagLine="Vivi l'avventura anche in ebook su tutti i dispositivi!"
							ebookElenco='<li><span class="ion-ios-checkmark-circle mr-2"></span> Vivi questa avventura ovunque tu sia!</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span><span class="ebook-feature-text"><em>Accessibile</em> per non vedenti e ipovedenti, in formato epub3.</span></li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Altri formati disponibili: Kindle, Mobi e PDF.</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo con uno screen reader o un lettore braille.</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo con Kindle, Kobo e altri eReader.</li>
							<li><span class="ion-ios-checkmark-circle mr-2"></span> Puoi leggerlo su tablet, smartphone o PC.</li>'
							ebookInfoAccessibilita="Per saperne di più sull'accessibilità, leggi (in italiano):"
							ebookLinkAccessibilita="https://www.eliosfera.it/ebook-con-contenuti-accessibili-eliosfera-editrice"
							ebookTitleLink="Link all'articolo Ebook con contenuti accessibili."
							ebookDescAccessibilita="Ebook con contenuti accessibili"
							ebookCallAction="Allora, cosa stai aspettando? L'avventura ti aspetta anche in digitale!"
							ebookButton="INIZIA IL VIAGGIO!"
							ebookLink='https://hemelslinn.s.gy/vh-web-hem-land'
						/>					

						<CreativeArticleTeaser article={latestArticle} />


						{/* SECTION ESTRATTO 2 */}
						{/*<Estratto2 
							estrattoId="gorilla"
							estrattoStile={EstrattoStyle2}
							estrattoTitolo="IL DILEMMA DEL GORILLA"
							estrattoContenuto="Un maestoso gorilla lo stava fissando con cipiglio. Le lunghe e possenti braccia erano puntate dritte con i pugni a terra. I severi occhi marroni risaltavano sullo sfondo nero del muso. Era come se gli stesse parlando. Deciditi, mostrati uomo, fai ciò che è giusto. Non puoi tradire i tuoi amici. Fatti aiutare, per amore di Khalìse. Sentiva riecheggiare queste frasi nella mente come se fosse quel fiero animale a infondergliele. Per qualche minuto i loro occhi rimasero fissi, scrutandosi. Infine il gorilla si sedette e il suo sguardo si rasserenò. Provò la stessa sensazione, come se gliel’avesse trasmessa."
							estrattoButton="ACQUISTA"
							estrattoButtonLink='https://amzn.to/43biilu'
						/>*/}
						

						{/*<Estratto2 
							estrattoId="gorilla"
							estrattoStile={EstrattoStyle2}
							estrattoTitolo="IL DILEMMA DEL GORILLA"
							estrattoContenuto="Un maestoso gorilla lo stava fissando con cipiglio. Le lunghe e possenti braccia erano puntate dritte con i pugni a terra. I severi occhi marroni risaltavano sullo sfondo nero del muso. Era come se gli stesse parlando. Deciditi, mostrati uomo, fai ciò che è giusto. Non puoi tradire i tuoi amici. Fatti aiutare, per amore di Khalìse. Sentiva riecheggiare queste frasi nella mente come se fosse quel fiero animale a infondergliele. Per qualche minuto i loro occhi rimasero fissi, scrutandosi. Infine il gorilla si sedette e il suo sguardo si rasserenò. Provò la stessa sensazione, come se gliel’avesse trasmessa."
							estrattoButton="SOSTIENI VERSO HEMELSLINN!"
							estrattoButtonLink='https://hemelslinn.s.gy/vh-web-hem-land'
						/>	*/}				


						{/* SECTION CONTATTACI 
						<Contattaci
							contattaciTitolo="CONTATTACI"
							contattaciTagLine="Se hai domande, utilizza questo modulo per inviarci il tuo messaggio"
							contattaciAction="sendemail.php"
							contattaciButton="   INVIA   " 
							contattaciConsensoPrivacy="Consenso alla privacy"
							contattaciConsenso="Acconsento al trattamento dei miei dati personali."
							contattaciPrivacy="Informativa sulla privacy"
							contattaciNomePlaceholder="Nome"
							contattaciEmailPlaceholder="Indirizzo Email"
							contattaciMessaggioPlaceholder="Inserisci qui il tuo mesaggio"
						/> */}

						{/* SECTION WIDGET */}
						<Widget
							widgetId="ProduzioniDalBasso"
							widgetTitolo="DIVENTA UNO DEI PRIMI 300!"
							widgetContenuto='Con il tuo sostegno:<br />
							<ul className="text-inner pl-md-5">
							<li>Porterai al mondo una space opera originale italiana.</li>
							<li>Avrai un accesso in anteprima al libro con anteprime audio-video, contenuti bonus e altro.</li>
							<li>Farai anche parte di una comunità narrativa che dà valore alla creazione letteraria dal basso.</li>
							<li>Avrai anche diverse altre ricompense tangibili che riguardano i volumi delle edizioni con copertina flessibile, con copertina cartonata e di quella digitale del romanzo Verso Hemelslinn di Maurizio Feruglio.</li>
							</ul>
							Questa non è solo una campagna: è un invito a esplorare con la Delphís i confini della libertà umana. Se senti che questa avventura ti appartiene, sostieni Verso Hemelslinn ora!'
							widgetButton="ENTRA NELL'EQUIPAGGIO!"
							widgetButtonLink='https://hemelslinn.s.gy/vh-web-hem-land'
						/>
						


						{/* SECTION PIEDONE */}
						<Piedone
							piedoneCallToAction='Ci sono viaggi che attraversano le stelle. E altri che attraversano le persone.'
							piedoneLinkTermConditions=''
							piedoneLinkCookies='/cookies'
							piedoneLinkPrivacy='/privacy'			
							piedoneIframe=''
							piedoneTwitter='https://x.com/Hemelslinn'
							piedoneInstagram='https://www.instagram.com/versohemelslinn/'
							piedoneFacebook='https://www.facebook.com/hemelslinn'
							piedoneTiktok='https://www.tiktok.com/@hemelslinn'
							piedoneDiscord=''
							piedonePinterest='https://it.pinterest.com/hemelslinn/'
							piedoneOpensea=''
							piedoneEliosfera='https://www.eliosfera.it/maurizio-feruglio-verso-hemelslinn-copertina-rigida-libro'
							piedoneYoutube='https://www.youtube.com/@VersoHemelslinn'
							piedoneCopyright="Eliosfera Editrice &copy;"
							piedoneCopyrightDisclaimer="Tutti i diritti riservati"
							piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
						/>

					</div>
					
					{AddLibrary('js/jquery.min.js')}
					{AddLibrary('js/jquery-migrate-3.0.1.min.js')}
					{AddLibrary('js/jquery.waypoints.min.js')}
					{AddLibrary('js/jquery.stellar.min.js')}
					{AddLibrary('js/owl.carousel.min.js')}
					{AddLibrary('js/jquery.magnific-popup.min.js')}
					{AddLibrary('js/aos.js')}
					{AddLibrary('js/jquery.animateNumber.min.js')}
					{AddLibrary('js/scrollax.min.js')}
					{AddLibrary('js/jquery.mb.YTPlayer.min.js')}
					{AddLibrary('js/bootstrap-datepicker.js')}
					{AddLibrary('js/jquery.timepicker.min.js')}
					{AddLibrary('js/main.js')}
				</div>
				
			</>
		);
	}
}

export default App;
